/** Australia (TGA) regulatory submission pathways — the dropdown options shown
 *  when a user picks AU at dossier dispatch time. Mirrors the CA file's shape
 *  so the dispatch form can plug it in with a country-key swap.
 *
 *  FIRST DRAFT — labels pending regulatory review. These reflect standard TGA
 *  filing classifications under the Therapeutic Goods (Medical Devices)
 *  Regulations 2002 (TG(MD)Regs) as of 2026 but have not yet been reviewed
 *  by a qualified Australian regulatory consultant. Do not rely on these labels
 *  as authoritative regulatory guidance.
 *
 *  ## Medical Devices — ARTG inclusion via TGA Conformity Assessment
 *
 *  TGA uses a risk-based classification scheme under the TG(MD)Regs 2002
 *  (Schedule 2 classification rules). Class I devices are the lowest risk
 *  (self-declared; no conformity-assessment dossier required — out of scope
 *  for this engine). Classes IIa, IIb, and III require a TGA conformity
 *  assessment (or Manufacturer's Evidence acceptance) leading to ARTG inclusion
 *  under ss 41FC/41FD/41FF of the Therapeutic Goods Act 1989.
 *
 *  Slug values MUST match the backend `_UI_CLASS_ALIASES` in
 *  `app/dossier/australia/dispatch_policy.py` exactly:
 *    "au-class-iia" → "IIa"
 *    "au-class-iib" → "IIb"
 *    "au-class-iii" → "III"
 */

import type { Product } from '@/features/product/types';
import type { SubmissionGroup } from './us-submission-pathways';

export const AU_SUBMISSION_PATHWAYS: SubmissionGroup[] = [
  {
    productType: 'device',
    label: 'Medical Device — TGA / ARTG (TG(MD)Regs 2002)',
    options: [
      { value: 'au-class-iia', label: 'Class IIa — TGA conformity assessment (Essential Principles)' },
      { value: 'au-class-iib', label: 'Class IIb — TGA conformity assessment (Essential Principles, extended evidence)' },
      { value: 'au-class-iii', label: 'Class III — TGA conformity assessment (Essential Principles + Clinical Evaluation Report)' },
    ],
  },
];

/** Pre-fill the picker with the most-common pathway per product type. */
export const AU_DEFAULT_BY_TYPE: Record<Product['product_type'], string> = {
  device:      'au-class-iia',
  drug:        'au-class-iia',
  biologic:    'au-class-iia',
  combination: 'au-class-iia',
};
